import { cva } from 'class-variance-authority'

export const toggleVariants = cva(
  `
    inline-flex
    items-center
    justify-center
    gap-2
    rounded-lg
    text-sm
    text-neutral-700
    font-medium
    transition-colors
    hover:bg-muted
    hover:text-muted-foreground
    focus-visible:outline-none
    focus-visible:ring-1
    focus-visible:ring-ring
    disabled:pointer-events-none
    disabled:opacity-50
    data-[state=on]:bg-accent
    data-[state=on]:text-accent-foreground
    [&_svg]:pointer-events-none
    [&_svg]:size-4
    [&_svg]:shrink-0
    `,
  {
    variants: {
      variant: {
        default: `
          bg-transparent
          hover:bg-neutral-50
          data-[state=on]:bg-green-0
          data-[state=on]:text-green-100
          data-[state=on]:hover:bg-green-0
          data-[state=on]:hover:text-green-100
          disabled:bg-neutral-50
          disabled:text-neutral-700
          `,
        outline: `
          border-1
          border-neutral-200
          bg-transparent
          hover:bg-neutral-50
          hover:text-accent-foreground
          hover:border-accent
          data-[state=on]:bg-green-0
          data-[state=on]:text-green-100
          data-[state=on]:border-green-50
          data-[state=on]:hover:bg-green-0
          data-[state=on]:hover:text-green-100
          data-[state=on]:hover:border-green-50
          data-[state=on]:hover:bg-gradient-to-b:none
          `,
      },
      size: {
        sm: `
          h-8
          px-2.5
          py-2
          min-w-8
          `,
        lg: `
          h-10
          px-3
          py-2
          min-w-10
          `,
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'sm',
    },
  }
)
